import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import { FLEXIBLE_CONTENT_BASE_SPACING } from '../../../constants/flexibleContentBaseSpacing'
import { html } from '../../../utils/html'
import { FlexibleContent } from '../flexibleContent'
import { FourColumnRowFragment } from '@gql'
import { ColumnCard } from '../../ColumnCard/columnCard'

export type FourColumnRowProps = FourColumnRowFragment & {
  verticallyCentre: boolean
}

export const FourColumnRow: React.FC<PropsWithChildren<FourColumnRowProps>> = ({ column1, column2, column3, column4, verticallyCentre, altBg, column1AltBg, column2AltBg, column3AltBg, column4AltBg }) => {
  const columns = [column1, column2, column3, column4]
  const altBgColumns = [column1AltBg, column2AltBg, column3AltBg, column4AltBg]

  return (
    <FlexibleContent row>
      <ColumnCard $altBg={altBg}>
        <Grid container spacing={FLEXIBLE_CONTENT_BASE_SPACING} alignItems={verticallyCentre ? 'center' : 'flex-start'}>
          {columns.map((col, i) => (
            <Grid item key={i} xs={12} sm={6} md={3}>
              <ColumnCard $altBg={altBgColumns[i]}>
                {col && html(col)}
              </ColumnCard>
            </Grid>
          ))}
        </Grid>
      </ColumnCard>
    </FlexibleContent>
  )
}